import { PaginationCriteria } from '../../core';

export interface CaseloadModel {
   id: string;
   name: string;
   isPrimary: boolean;
}

export interface GetCaseloadsCriteria extends PaginationCriteria {
   locationId?: number;
}
